<template>
    <div class="Pla-Linha-Principal">
        <PageTitle icon="fa fa-map" main="Linhas"
            sub="Inforções de linhas" />
        <div class="Pla-Linha-Principal">
            <b-card no-body>
                <b-tabs>                    
                    <b-tab title="Pontos" active><PontoCadastro /></b-tab>                                                                                                                        
                    <b-tab title="Linhas" active><Linha /></b-tab>                                                                                                                        
                </b-tabs>
            </b-card>
        </div>
    </div>
</template>

<script>
import PageTitle from '../template/PageTitle'
import PontoCadastro from '../pla_linha/PontoCadastro'
import Linha from '../pla_linha/Linha'
export default {
    name: 'LinhaPrincipal',    
    components: { PageTitle, PontoCadastro, Linha}
    
}
</script>

<style>

</style>






